import { z } from 'zod';

/**
 * 詳細画面を編集モードで開くための検索パラメータ。
 *
 * 「手動で追加」は空のレコードを作ってから詳細画面へ遷移するため、着地した時点で
 * 編集モードに入っていないと、ユーザーが名称を書き始める前に Edit を押す一手間が挟まる。
 * 編集モードの持ち方は画面ごとに違う（単位はローカル state、体系は Context）ので、
 * 初期モードを外から与える口としてこの検索パラメータだけを共通にしている。
 *
 * `mode` を省略可能にしているのは、通常の遷移では URL にパラメータを残さないため。
 *
 * 想定外の値は `catch` で未指定に倒す。ここで throw すると `validateSearch` から
 * エラー境界に抜け、クライアント側のパラメータの問題なのに全画面の「サーバーエラー」に
 * なってしまう。URL は共有・ブックマークされて壊れた値で戻ってくるため、
 * 閲覧モードで開くのが正しい振る舞い。
 */
export const AttendanceDetailEditModeSearchSchema = z.object({
  mode: z.literal('edit').optional().catch(undefined)
});